const SECTION_IDS = new Set([
  'strategy-overview',
  'as-is-state',
  'goal-setting',
  'action-plan',
  'implementation-overview',
  'photo-upload',
  'post-scheduler',
  'review-management',
  'qa-checklist',
  'governance-overview',
  'live-preview',
  'activity-log',
  'alerts-permissions',
  'publishing-monitoring',
  'search-performance-trends',
  'review-reputation-insights',
  'content-engagement-performance',
  'monthly-optimization-action-plan',
]);

const PATH_TO_SECTION: Record<string, string> = {
  '/implementation/reviews': 'review-management',
  '/implementation/posts': 'post-scheduler',
  '/implementation/photos': 'photo-upload',
  '/implementation/checklist': 'qa-checklist',
  '/strategy/asis': 'as-is-state',
  '/strategy/action-plan/technical': 'action-plan',
  '/onboarding': 'governance-overview',
  '/governance': 'governance-overview',
  '/governance/alerts': 'alerts-permissions',
  '/optimization/performance-trends': 'search-performance-trends',
};

export function resolveSectionId(path?: string | null): string {
  if (!path) return 'governance-overview';
  const value = path.trim();
  if (SECTION_IDS.has(value)) return value;

  const normalized = value.startsWith('/') ? value.toLowerCase() : `/${value.toLowerCase()}`;
  return PATH_TO_SECTION[normalized] || 'governance-overview';
}
